import { CategoryPageData } from './category-page';
import { Project, ProjectEvent } from '../../model/project';
import {ReplaySubject} from "rxjs";
import {PaginatorEvent} from "@/model/paginator";

declare let isJury: boolean;

export class DataService {

    public categoryData: CategoryPageData = new CategoryPageData();

    constructor() {
    }


    public get categories(){
        return this.categoryData.categories;
    }
    public get countries(){
        return this.categoryData.countries;
    }

    public get category(){
        return this.categoryData.category;
    }
    public get country(){
        return this.categoryData.country;
    }



    public get projects(){
        return this.categoryData.projects;
    }

    public get paginator(){
        return this.categoryData.paginator;
    }
    public updateProjects(callback:any | null=null){
        this.categoryData.updateProjects(callback);
    }
    public clearProjects(){
        this.categoryData.clearProjects();
    }



}

export const dataService = new DataService();